import { CompanyAuthProvider } from '@src/context/auth/CompanyAuthProvider';
import { CategoryProvider } from '@src/context/CategoryContext';
import { DxDiagnosisMenuProvider } from '@src/context/DxDiagnosisMenuContext';
import { EventMenuProvider } from '@src/context/EventMenuContext';
import { UserNavigationProvider } from '@src/context/UserNavigationContext';
import React from 'react';

type CompanyProvidersProps = {
  children: React.ReactNode;
};

export const CompanyProviders = ({ children }: CompanyProvidersProps) => {
  return (
    <CompanyAuthProvider>
      <UserNavigationProvider>
        <CategoryProvider>
          <EventMenuProvider>
            <DxDiagnosisMenuProvider>{children}</DxDiagnosisMenuProvider>
          </EventMenuProvider>
        </CategoryProvider>
      </UserNavigationProvider>
    </CompanyAuthProvider>
  );
};
